const GREEN_BADGE_STYLE = {
    color: 'rgb(255 255 255)',
    backgroundColor: 'rgb(17 165 77 / 75%)',
    borderColor: 'rgb(3 120 50 / 30%)',
};

export function cmsPublicationStatusMeta(vm, entity) {
    if (typeof entity?.is_active === 'boolean' && !entity.is_active) {
        return {
            label: vm.$t('Disabled'),
            classes: 'bg-red-50 text-red-700 border-red-200',
            dotClass: 'bg-red-500',
        };
    }

    if (!entity?.published_at) {
        return {
            label: vm.$t('Unveröffentlicht'),
            classes: 'bg-amber-50 text-amber-700 border-amber-200',
            dotClass: 'bg-amber-500',
        };
    }

    if (entity?.has_unpublished_changes) {
        return {
            label: vm.$t('Unveröffentlichte Änderungen'),
            classes: 'bg-amber-50 text-amber-700 border-amber-200',
            dotClass: 'bg-amber-500',
        };
    }

    return {
        label: vm.$t('Veröffentlicht'),
        classes: 'border',
        style: GREEN_BADGE_STYLE,
        dotClass: 'bg-[#11A54D]',
    };
}

export function cmsActivationStatusMeta(vm, entity) {
    if (!entity?.is_active) {
        return {
            label: vm.$t('Inaktiv'),
            classes: 'bg-red-50 text-red-700 border-red-200',
            dotClass: 'bg-red-500',
        };
    }

    return {
        label: vm.$t('Aktiv'),
        classes: 'border',
        style: GREEN_BADGE_STYLE,
        dotClass: 'bg-[#11A54D]',
    };
}
